<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "patientWrapper"
};
</script>

<style scoped></style>
